export const FILE_NAMES = {
    ASSETSCONFIG: 'assetsConfig.json',
    PRODUCTSDATA: 'productData.json',
    PAGES: 'pages.json'
}